export enum BroadcastPanelCategory {
    otherCountries = 0,
    national = 1,
    regional = 2,
    outOfMarket = 3,
}
